import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import * as sharedActions from "../redux/actions/shared";
import { srcPath } from "../util/Path";

export interface Query {
  grade: string | null;
  unit: string | null;
  game: string | null;
}

export const useQuery = () => {
  const dispatch = useDispatch();

  const query = new URLSearchParams(useLocation().search);

  const grade = query.get("grade");
  const unit = query.get("unit");
  const game = query.get("game");

  useEffect(() => {
    dispatch(sharedActions.queryInit({ grade, unit, game }));
    dispatch(sharedActions.configInit());
  }, [dispatch, grade, unit, game]);
};

export const useBackground = (grade: number | null, game: string) => {
  const [bg, setBg] = useState<string | undefined>();

  useEffect(() => {
    grade && setBg(srcPath(`${game}/bg/p${grade}.png`));
  }, [grade, game]);

  return bg;
};
